(() => {
  const landing = document.querySelector('[data-paw-landing]');
  if (!landing) return;

  const revealItems = landing.querySelectorAll('.paw-reveal');
  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.14 }
  );
  revealItems.forEach((item) => revealObserver.observe(item));

  const hero = landing.querySelector('.paw-hero');
  const heroImage = landing.querySelector('.paw-hero__media img');
  const mobileBuy = landing.querySelector('.paw-mobile-buy');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const onScroll = () => {
    const y = window.scrollY;
    if (heroImage && !reduceMotion && window.innerWidth > 749) {
      heroImage.style.transform = `translate3d(0, ${Math.min(y * 0.08, 40)}px, 0) scale(1.035)`;
    }
    if (mobileBuy && hero) {
      mobileBuy.classList.toggle('is-visible', y > hero.offsetHeight * 0.72);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
